module.exports = __webpack_public_path__ + "static/media/logo.85a0d6be.png";